import { createFileRoute } from "@tanstack/react-router";

import { PayoutsPage } from "../../../../areas/admin/payouts/PayoutsPage";

export const Route = createFileRoute("/app/_seller/admin/payouts")({
  component: PayoutsPage,
});
